//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ImageList from "../../../../components/ImageList";
import ImageUploader from "../../../../components/ImageUploader";

export default {
    name: "workOrderLogs",
    components: {ImageUploader, ImageList},
    props: {
        workOrderId: {
            type: Number,
            required: true
        }
    },
    data() {
        return {
            list: []
        }
    },
    methods: {
        getLogs() {
            abp.ajax.get('/api/services/app/WorkOrder/GetWorkOrderOperationLogList?workOrderId=' + this.id).then((res) => {
                this.list = [];
                this.list.push(...res.data.result)
            }).finally(() => {

            });
        }
    },
    created() {
        this.id = parseInt(this.workOrderId) || 0;
        if (this.id > 0) {
            this.getLogs()
        }
    },
    watch: {
        workOrderId() {
            this.id = this.workOrderId;
            this.getLogs()
        }
    }
}
